import React from 'react';
import ReactDOM from 'react-dom';

import ChoroplethPatternDefiner from './ChoroplethPatternDefiner';

export default class ChoroplethLegend extends React.Component {
  TRUE_SVG_WIDTH = 625;
  SVG_WIDTH  = 500;
  SVG_SCALING = this.SVG_WIDTH / this.TRUE_SVG_WIDTH;
  SVG_HEIGHT = this.SVG_SCALING * 20;
  SVG_MARGIN = this.SVG_SCALING * 5;

  getColorBin(index) {
    const props = this.props;
    const numOfBins = props.colorBins.length;
    const binWidth = (this.SVG_WIDTH - (numOfBins - 1) * this.SVG_MARGIN) / numOfBins
    const fill = props.accessibilityEnabled ?
      `url(#${props.patternNames[index]})` :
      `rgb(${props.colorBins[index]})`;
    return (
      <rect key={index} x={(binWidth + this.SVG_MARGIN) * index} y="0" width={binWidth} height={this.SVG_HEIGHT} fill={fill} />
    );
  };

  render() {
    let legendText = this.props.legendText || {};
    const activeCategory = this.props.activeCategory;
    const colorBinClass = this.props.accessibilityEnabled ? "" : "plain-color-bins";
    return (
      <div className="ChoroplethLegend">
        <div className="gradient-wrapper">

          <svg className={"svg-color-bins " + colorBinClass} viewBox={`0 0 ${this.SVG_WIDTH} ${this.SVG_HEIGHT}`} preserveAspectRatio="xMinYMin" width="100%">
            {this.props.colorBins.map((bin, i) => this.getColorBin(i))}
          </svg>
          <div className="gradient-labels">
            <div className="gradient-label left">{ activeCategory.min  || "Weakest Representation" }</div>
            <div className="gradient-label right">{ activeCategory.max || "Strongest Representation" }</div>
          </div>
        </div>
        <div className="no-data-indicator-wrapper">
          <svg className="no-data-indicator-svg" viewBox={`0 0 25 25`} width="25" height="25">
            <rect x="0" y="0" width="25" height="25" fill='url(#no-data-pattern)' />
          </svg>
          <div className="no-data-indicator-text">
            {legendText.noDataIndicator || "Not Enough Data"}
          </div>
        </div>
        {/* <div className="user-location-indicator-wrapper">
          <div className="user-location-indicator">
            <span>{ legendText.locationIndicator || "Where you live" }</span>
          </div>
        </div> */}
      </div>
    )
  }
}
